<template>
    <div>
        <input class="form-control" type="text" v-model.number="integerAnswer"/>
        
        <button class="btn-saved mt-2" @click="onAnswerChanged">
            Save
        </button>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    import constants from "@/entities/constants";
    import {IntegerAnswer} from "@/entities/questionaire/answers/IntegerAnswer";

    @Component({
        name: constants.answerTypes.IntegerAnswer.componentName,
    })
    export default class AppIntegerAnswer extends Vue {
        public integerAnswer: number | null = null;

        @Prop()
        questionId!: number;

        @Prop()
        answer!: IntegerAnswer;

        answerChanged() {
            this.$events.emit("answerChanged", new IntegerAnswer(this.questionId, this.integerAnswer));
        }
    }
</script>

<style lang="scss" scoped>
    input[type="text"] {
        width: 50px;
    }

    .btn-saved {
        background: white;
        color: #2f45a5;
        font-weight: 600;
        height: 36px;
        padding: 0 1rem;
        border-radius: 8px;
        border: 2px solid rgba(47, 69, 165, 0.35);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transition: all 0.3s ease;
        cursor: pointer;
        font-size: 0.875rem;
        display: flex;
        align-items: center;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    }

    .btn-saved:not(:disabled):hover {
        background: linear-gradient(135deg, #2f45a5, #667bf2);
        border-color: transparent;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(47, 69, 165, 0.25);
    }

    .btn-saved:active:not(:disabled) {
        transform: translateY(0);
    }

    .btn-saved:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    .btn-saved:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(102, 123, 242, 0.2);
    }

    @media only screen and (min-width: 992px) {
        .btn-saved {
            height: 44px;
            padding: 0 1.75rem;
            font-size: 1rem;
        }
    }
</style>
